import React, {Fragment} from "react";
import {connect} from "react-redux";

import ApplyPopup from "./popups/applyPopup";
import UserPopup from "./popups/userPopup/userPopup";
import ConfirmPopup from "./popups/confirmPopup";
import MessageBox from "./popups/messageBox";
import LoaderView from "./ui/loaderView";
import MobileRotateButton from "./ui/mobileRotateButtonHorizontalNew";
import DocuSignLayer from "./visComponents/docuSignLayer";
import DepositPopup from "./popups/depositPopup";
import AssignQuotePopup from "./popups/assignQuotePopup/assignQuotePopup";
import OrderCompletePopup from "./popups/orderCompletePopup/orderCompletePopup";
// import ContractSigningLayer from "./popups/contractSign/contractSigningLayer";
import CookieMessage from "./common/cookieMessage";
import SuccessNotification from "./ui/successNotification";
import SqftFeaturesPopupWrapper from "./popups/sqftFeaturesPopup/sqftFeaturesPopupWrapper";
import WizardConflictPopup from "./popups/wizardConflictPopup/wizardConflictPopup";
import SuperAdminLoginPopup from "./qkbPages/superAdmin/SuperAdminLoginPopup";
import {IS_SUPER_ADMIN} from "../config";
import SuperAdminToolSettingsPopup from "./qkbPages/superAdmin/SuperAdminToolSettingsPopup";
import DiscountAllFinanceOptionsPopup from "./priceWorksheet/discountAllFinanceOptionsPopup";
import CheckoutPopup from "./popups/checkoutPopup";
import UIPopup from "./popups/UIPopup/UIPopup";


const Popups = (props) => {

  const {messageBoxState, applyPopupOpened, showDocusign} = props;

  return (
    <Fragment>
      {messageBoxState.uiPopupState.opened ? <UIPopup/> : null}
      {applyPopupOpened ? <ApplyPopup/> : null}
      <UserPopup/>
      <ConfirmPopup/>
      <WizardConflictPopup/>
      <MessageBox state={messageBoxState}/>
      <LoaderView/>
      <MobileRotateButton/>
      {showDocusign ? <DocuSignLayer /> : null}
      <DepositPopup />
      <CheckoutPopup />
      <AssignQuotePopup/>
      <OrderCompletePopup/>
      <SqftFeaturesPopupWrapper/>
      {/*{contractSigningVisible ? <ContractSigningLayer /> : null}*/}
      {!document.kvConfig.kioskMode ? <CookieMessage/> : null}
      <SuccessNotification/>
      {IS_SUPER_ADMIN ? (
        <Fragment>
          <SuperAdminLoginPopup/>
          <SuperAdminToolSettingsPopup/>
        </Fragment>
      ) : null}
      <DiscountAllFinanceOptionsPopup/>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  return {
    messageBoxState: store.messageBoxState,
    applyPopupOpened: store.cartState.applyPopupOpened,
    showDocusign: store.docuSignState.showDocusign,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Popups)
